import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from '../styles/async-button.module.scss';

export default function (props: any) {
  const [clicked, setClicked] = useState(false);
  const [loadingInternal, setLoadingInternal] = useState(false);
  const { loading, children, onClick, ...others } = props;

  useEffect(() => {
    if (!clicked) return;

    let cancel = false;
    async function task() {
      setLoadingInternal(true);
      if (onClick) {
        await onClick();
      }
      if (!cancel) {
        setLoadingInternal(false);
        setClicked(false);
      }
    }
    task();
    return () => {
      cancel = true;
    };
    // onClick を依存関係に含めると、再レンダリングの際に useEffect() が呼ばれて
    // loadingInternal = false にできないため、onClick の依存を外す
    // その際に出る警告を無効化
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [clicked]);

  return (
    <Button
      {...others}
      disabled={loadingInternal || loading || props.disabled}
      onClick={() => {
        setClicked(true);
      }}
    >
      <div className={styles.wrapper}>
        {children}
        {(loadingInternal || loading) && (
          <CircularProgress size={24} className={styles.buttonProgress} />
        )}
      </div>
    </Button>
  );
}
